import React from 'react';
import ReactDOM from 'react-dom';
export default class Popout extends React.Component {
    constructor(props) {
        super(props);
        this._el = null;
        this._popup = null;
        this.popout = this.popout.bind(this);
    }
    popout() {
        if (this._el) {
            const elRect = this._el.getBoundingClientRect();
            const features = this._toFeatures({
                title: this.props.title,
                toolbar: 'yes',
                scrollbars: 'no',
                resizable: 'yes',
                width: elRect.width + 50,
                height: elRect.height + 50,
                top: (window.innerHeight / 2) - elRect.height,
                left: (window.innerWidth / 2) - elRect.width,
            });
            this._popup = window.open('', '_blank', features);
            if (this._popup) {
                const popoutRoot = this._popup.document.createElement('div');
                popoutRoot.id = 'root';
                this._popup.document.body.appendChild(popoutRoot);
                ReactDOM.render(React.cloneElement(this.props.children, { inPopup: true }), popoutRoot);
            }
        }
    }
    popin() {
        if (this._popup) {
            this._popup.close();
        }
    }
    componentDidMount() {
        if (this.props.isPopped) {
            this.popout();
        }
    }
    componentWillUpdate(newProps) {
        if (newProps.isPopped) {
            this.popout();
        }
        else {
            this.popin();
        }
    }
    render() {
        return (React.createElement("div", { ref: (el) => this._el = el, style: { width: '100%', height: '100%' } }, this.props.children));
    }
    _toFeatures(props) {
        return Object.keys(props)
            .filter((k) => typeof props[k] !== 'undefined')
            .map((k) => `${k}=${props[k]}`)
            .join(',');
    }
}
